import Branch from "branch-sdk";
import { useState, useEffect } from "react";
import { BranchSessionData } from "@brandclub/common-ui";
import { useBrandAppConfigWithFallback } from "@/api/cache/appConfigQueryOptions";

const useBranchIOSession = () => {
  const { data: brandAppConfig } = useBrandAppConfigWithFallback();
  const [branchSessionData, setBranchSessionData] =
    useState<Branch.SessionData | null>(null);

  useEffect(() => {
    const fetchBranchSessionData = async () => {
      const apiKey = brandAppConfig?.branchIOConfig?.key;
      if (!apiKey) {
        return;
      }

      try {
        const data = await BranchSessionData({ branchKey: apiKey });
        setBranchSessionData(data);
      } catch (error) {
        console.error("Error fetching Branch session data:", error);
      }
    };

    fetchBranchSessionData();
  }, [brandAppConfig]);

  return branchSessionData;
};

export default useBranchIOSession;
